export var testidFactory = function testidFactory(prefix) {
  return function (str) {
    return "".concat(prefix).concat(str ? "-".concat(str) : '');
  };
};